export default __webpack_public_path__ + "static/media/enjoy-meal.a6d94c53.png";